import { MAX_STEPS } from '@config/constants'

export const sanitizeStep = (stepInput) =>
  Math.max(0, Math.min(MAX_STEPS - 1, stepInput))

export const sanitizeStepsFinished = (stepInput, currentStepsFinished) =>
  Math.max(sanitizeStep(stepInput), currentStepsFinished)
